module.exports = __webpack_public_path__ + "static/media/rni-cloud-logo-inverted.4cc1cc3d.svg";